<template>
  <order-form :url="url" result-router-name="kkresult" business-type="kk"/>
</template>

<script>
import OrderForm from './../page/form';
import Api from './api';
export default {
  name: 'OrderFormVue',
  components: {
    OrderForm
  },
  data () {
    return {
      url: Api.KKPREFIX
    };
  },
  mounted () {
  },
  created () {
  },
  watch: {
  },
  computed: {
  },
  methods: {

  },
  beforeDestroy() {
  }
};
</script>
<style scoped  lang="scss">
</style>
<style>
</style>
